import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../../firebase';

const EditPanierModal = ({ show, handleClose, panier, users, plats, onSave, updatePanierState }) => {
    const [selectedUser, setSelectedUser] = useState(panier.user);
    const [selectedPlats, setSelectedPlats] = useState(panier.plat || []);

    useEffect(() => {
        setSelectedUser(panier.user);
        setSelectedPlats(panier.plat || []);
    }, [panier]);

    const handleSave = async () => {
        try {
            const panierRef = doc(db, 'panier', panier.id);
            await updateDoc(panierRef, {
                user: selectedUser,
                plat: selectedPlats
            });
            onSave();
            updatePanierState(); // Appel de la fonction pour mettre à jour les paniers dans Panier.js
            handleClose();
        } catch (error) {
            console.error("Error updating panier: ", error);
        }
    };

    const handlePlatChange = (index, field, value) => {
        const newPlats = [...selectedPlats];
        newPlats[index] = { ...newPlats[index], [field]: value };
        setSelectedPlats(newPlats);
    };

    const addPlat = () => {
        setSelectedPlats([...selectedPlats, { id: '', quantite: 1 }]);
    };

    const removePlat = (index) => {
        const newPlats = [...selectedPlats];
        newPlats.splice(index, 1);
        setSelectedPlats(newPlats);
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Modifier Panier</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group controlId="formUser">
                        <Form.Label>Utilisateur</Form.Label>
                        <Form.Control
                            as="select"
                            value={selectedUser}
                            onChange={(e) => setSelectedUser(e.target.value)}
                        >
                            {users.map((user) => (
                                <option key={user.id} value={user.id}>
                                    {user.nom} ({user.email})
                                </option>
                            ))}
                        </Form.Control>
                    </Form.Group>
                    <Form.Label>Plats</Form.Label>
                    {selectedPlats.map((plat, index) => (
                        <div key={index} className="d-flex align-items-center mb-2">
                            <Form.Control
                                as="select"
                                value={plat.id}
                                onChange={(e) => handlePlatChange(index, 'id', e.target.value)}
                                className="mr-2"
                            >
                                <option value="">Sélectionnez un plat</option>
                                {plats.map((p) => (
                                    <option key={p.id} value={p.id}>
                                        {p.nom}
                                    </option>
                                ))}
                            </Form.Control>
                            <Form.Control
                                type="number"
                                min="1"
                                value={plat.quantite}
                                onChange={(e) => handlePlatChange(index, 'quantite', e.target.value)}
                                className="mr-2"
                                placeholder="Quantité"
                            />
                            <Button variant="danger" onClick={() => removePlat(index)}>
                                X
                            </Button>
                        </div>
                    ))}
                    <Button variant="secondary" onClick={addPlat}>
                        Ajouter un plat
                    </Button>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Annuler
                </Button>
                <Button variant="primary" onClick={handleSave}>
                    Enregistrer
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EditPanierModal;
